import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { Location } from "../../domain/models";
import { LocationsRepository } from "../../repositories";


@Injectable({providedIn: 'root'})
export class GetPrivateLocationUsecase implements UseCase<string, Location> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(publicLocationId: string): Observable<Location> {
    return this.locationRepository.getPrivateLocation(publicLocationId);
  }
}
